import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./copActions";
import { userLogoutReceived } from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: null,
  copValues: []
});

//is action payload immutable?
const copReducer = handleActions(
  {
    [Actions.fetchCopValuesRequested](state) {
      return state.set("isFetchingData", true);
    },
    [Actions.fetchCopValuesReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", null)
        .set("copValues", Immutable.fromJS(action.payload));
    },
    [Actions.fetchCopValuesFailed](state, action) {
      return state.set("isFetchingData", false).set("error", action.payload);
    },
    [combineActions(
      Actions.setCopValuesFailed,
      Actions.bulkSetCopValuesFailed
    )](state, action) {
      return state.set("error", action.payload);
    },
    [userLogoutReceived](state, action) {
      return initialState;
    },
    [Actions.setCopValuesReceived](state, action) {
      const { model, ahriCertification, copValues } = action.payload;
      return state.update("copValues", values => {
        const index = values.findIndex(cop => {
          return cop.get("model") === model;
        });
        return values.update(index, value => {
          return (
            value &&
            value
              .set("ahriCertification", ahriCertification)
              .set("copValues", Immutable.fromJS(copValues))
          );
        });
      });
    }
  },
  initialState
);

export { copReducer };
export default copReducer;



// WEBPACK FOOTER //
// ./src/features/cop/store/copReducer.js